/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single row in the market statistics table
 * @export
 * @interface MarketStatisticsItemDto
 */
export interface MarketStatisticsItemDto {
    /**
     * Unique identifier of the subscriber
     * @type {string}
     * @memberof MarketStatisticsItemDto
     */
    subscriberId: string;
    /**
     * Full name of the subscriber
     * @type {string}
     * @memberof MarketStatisticsItemDto
     */
    subscriberName: string;
    /**
     * Type of subscriber (e.g., "Individual", "Company")
     * @type {string}
     * @memberof MarketStatisticsItemDto
     */
    subscriberType?: string;
    /**
     * Date calendaire (ISO sans Z, ex "2026-01-29T00:00:00") — afficher le jour tel quel, jamais de conversion de fuseau
     * 
     * @type {string}
     * @memberof MarketStatisticsItemDto
     */
    customerSince?: string;
    /**
     * Number of active contracts
     * @type {number}
     * @memberof MarketStatisticsItemDto
     */
    contractCount?: number;
    /**
     * Number of simulations performed
     * @type {number}
     * @memberof MarketStatisticsItemDto
     */
    simulationCount?: number;
    /**
     * Total premium amount (excluding tax)
     * @type {number}
     * @memberof MarketStatisticsItemDto
     */
    totalPremiumHT?: number;
    /**
     * List of product names the subscriber has
     * @type {Array<string>}
     * @memberof MarketStatisticsItemDto
     */
    products?: Array<string>;
    /**
     * Statut du souscripteur (libellé français prêt à afficher)
     * @type {string}
     * @memberof MarketStatisticsItemDto
     */
    status?: string;
}

/**
 * Check if a given object implements the MarketStatisticsItemDto interface.
 */
export function instanceOfMarketStatisticsItemDto(value: object): value is MarketStatisticsItemDto {
    if (!('subscriberId' in value) || value['subscriberId'] === undefined) return false;
    if (!('subscriberName' in value) || value['subscriberName'] === undefined) return false;
    return true;
}

export function MarketStatisticsItemDtoFromJSON(json: any): MarketStatisticsItemDto {
    return MarketStatisticsItemDtoFromJSONTyped(json, false);
}

export function MarketStatisticsItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketStatisticsItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriberId': json['subscriberId'],
        'subscriberName': json['subscriberName'],
        'subscriberType': json['subscriberType'] == null ? undefined : json['subscriberType'],
        'customerSince': json['customerSince'] == null ? undefined : json['customerSince'],
        'contractCount': json['contractCount'] == null ? undefined : json['contractCount'],
        'simulationCount': json['simulationCount'] == null ? undefined : json['simulationCount'],
        'totalPremiumHT': json['totalPremiumHT'] == null ? undefined : json['totalPremiumHT'],
        'products': json['products'] == null ? undefined : json['products'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function MarketStatisticsItemDtoToJSON(json: any): MarketStatisticsItemDto {
    return MarketStatisticsItemDtoToJSONTyped(json, false);
}

export function MarketStatisticsItemDtoToJSONTyped(value?: MarketStatisticsItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriberId': value['subscriberId'],
        'subscriberName': value['subscriberName'],
        'subscriberType': value['subscriberType'],
        'customerSince': value['customerSince'],
        'contractCount': value['contractCount'],
        'simulationCount': value['simulationCount'],
        'totalPremiumHT': value['totalPremiumHT'],
        'products': value['products'],
        'status': value['status'],
    };
}

